import type { ComponentType } from "react";
import type { RouteObject } from "react-router";
import { PermissionGate } from "@saas/ui";
type M = { default: ComponentType };
const page =
  (f: () => Promise<M>): RouteObject["lazy"] =>
  async () => ({ Component: (await f()).default });
/** 権限で守るページ（無ければ「権限がありません」。サーバ側も同じ権限で守る） */
const guarded =
  (f: () => Promise<M>, anyOf: string[]): RouteObject["lazy"] =>
  async () => {
    const Page = (await f()).default;
    const Guarded = () => (
      <PermissionGate anyOf={anyOf}>
        <Page />
      </PermissionGate>
    );
    return { Component: Guarded };
  };
export const taskRoutes: RouteObject[] = [
  { path: "/tasks", lazy: page(() => import("./pages/TaskListPage.js")) },
  /** 管理（会社のプロジェクト一覧・所有者の変更・容量・出所が消えたカード）。task.board.manage */
  {
    path: "/tasks/admin",
    lazy: guarded(() => import("./pages/TaskAdminPage.js"), [
      "task.board.manage",
    ]),
  },
  {
    path: "/tasks/projects/:id",
    lazy: page(() => import("./pages/TaskBoardPage.js")),
  },
  {
    path: "/tasks/projects/:id/sheets/:sheetId",
    lazy: page(() => import("./pages/TaskBoardPage.js")),
  },
  {
    path: "/tasks/boards/:id",
    lazy: page(() => import("./pages/TaskBoardPage.js")),
  },
];
export const taskPublicRoutes: RouteObject[] = [
  {
    path: "/public/tasks/:id",
    lazy: page(() => import("./pages/PublicTaskBoardPage.js")),
  },
  {
    path: "/public/tasks/:id/sheets/:sheetId",
    lazy: page(() => import("./pages/PublicTaskBoardPage.js")),
  },
];
